import { render, staticRenderFns } from "./gold-list.vue?vue&type=template&id=f5c511a2&scoped=true"
import script from "./gold-list.vue?vue&type=script&lang=js"
export * from "./gold-list.vue?vue&type=script&lang=js"
import style0 from "./gold-list.vue?vue&type=style&index=0&id=f5c511a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c511a2",
  null
  
)

export default component.exports